import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState,
  useRef
} from 'react';
//import { BigNumber } from 'ethers';
import { SignMessage } from './SignMessage';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { SectionDivider } from './SectionDivider';
import { Row, Col, Form, Button } from 'react-bootstrap'

import { create, CID, IPFSHTTPClient } from "ipfs-http-client";

//BUSD_LIVE
//import BUSD_Artifact from '../artifacts/BUSD_LIVE/BUSD_LIVE.json';
//import BUSD_Address from '../artifacts/BUSD_LIVE/BUSD_LIVE-address.json';

/*
//BUSD_TEST
import BUSD_Artifact from '../artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import BUSD_Address from '../artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//SAFUUTEST
import SAFUU_Artifact from '../artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import SAFUU_Address from '../artifacts/contracts/SAFUUToken.sol/SAFUUToken-address.json';

//Contract TEST
import ERC721GameNFTArtifact from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import ERC721GameNFTAddress from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';

const projectId = '2IokpGwCpHQJeI02EcfiZfX8IPk';
const projectSecret = 'f3aecb0b3d2e8309f1531dab7edfed87';

*/

//BUSD LIVE
import BUSD_Artifact from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken.json';
import BUSD_Address from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//SAFUU LIVE
import SAFUU_Artifact from '../live_artifacts/contracts/SAFUUToken.sol/SAFUUToken.json';
import SAFUU_Address from '../live_artifacts/contracts/SAFUUToken.sol/SAFUUToken-address.json';

//Contract LIVE
//import ERC721GameNFTArtifact from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
//import ERC721GameNFTAddress from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';


//Contract LIVE
import OGNFTArtifact from '../live_artifacts/contracts/OGNFT.sol/OGNFT.json';
import OGNFTAddress from '../live_artifacts/contracts/OGNFT.sol/OGNFT-address.json';

//Live IPFS
const projectId = '2KbB1CiSBOgCSVU2nBnP1fQV0oD';
const projectSecret = '8733b6fb7fd630bdf4720d44ea63b475';

const authorization = "Basic " + btoa(projectId + ":" + projectSecret);

const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function OGADMINPApp(): ReactElement {
  return (
    <StyledAppDiv>
      <NFTCreateADMINContract />
    </StyledAppDiv>
  );
}

export function NFTCreateADMINContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();
  const [NFTContract, setNFTContract] = useState<Contract>();
  const [NFTContractAddr, setNFTContractAddr] = useState<string>('');

  const [image, setImage] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const reffirstRef = useRef(null);

  const [nftTokenName, setTokenName] = useState<string>('');
  const [nftTokenSymbol, setTokenSymbol] = useState<string>('');
  const [nftTokenOwner, setTokenOwner] = useState<string>('');
  const [approveAmountInput, setApproveAmountInput] = useState<string>('');
  const [buyCFALPHAButton, setBuyCFALPHAButton] = useState<string>('APPROVE BUSD & MINT $CFALPHA NFT');
  const [buyCFALPHASafuuButton, setBuyCFALPHASafuuButton] = useState<string>('APPROVE SAFUU & MINT $CFALPHA NFT');

  const [totalBUSDRaised, setTotalBUSDRaised] = useState(0);
  const [totalSAFUURaised, setTotalSAFUURaised] = useState(0);
  const [busdBalance, setbusdBalance] = useState(0);
  const [safuuBalance, setsafuuBalance] = useState(0);
  const [totalNFTSupply, setTotalNFTSupply] = useState(0);

  const [transferBUSDAmountInput, setTransferBUSDAmountInput] = useState<string>('');
  const [transferSAFUUAmountInput, setTransferSAFUUAmountInput] = useState<string>('');
  
  let ipfs: IPFSHTTPClient | undefined;
  try {
    ipfs = create({
      url: "https://ipfs.infura.io:5001/api/v0",
      headers: {
        authorization,
      },
    });
  } catch (error) {
    console.error("IPFS error ", error);
    ipfs = undefined;
  }

  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

  function handleAttachContract() {

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function attachNFTContract(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        OGNFTArtifact.abi,
        OGNFTArtifact.bytecode,
        signer
      );

      try {
        //NOTE: ALWAYS PRE-DEPLOYED
        //const p2eGameContract = await P2EGame.deploy('Cosmic Force','CFX');
        //await p2eGameContract.deployed();

        const nftContract = await NFT.attach(OGNFTAddress.address);
       
        setNFTContract(nftContract);
 
       // window.alert(`P2EGame deployed to: ${p2eGameContract.address}`);

        const tokenName = await nftContract.name();
        const tokenSymbol = await nftContract.symbol();
        const tokenOwner = await nftContract.owner();
        const totalSupply = await nftContract.totalSupply();

        setNFTContractAddr(nftContract.address);
        setTokenName(tokenName);
        setTokenSymbol(tokenSymbol);
        setTokenOwner(tokenOwner);
        setTotalNFTSupply(Number(totalSupply));

        //Chech if BUSD approved and change to MINT buttin if so
        handleCheckApproveBUSD();
        handleCheckApproveSAFUU();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }

  function handleUploadToIPFS(event: ChangeEvent<HTMLInputElement>): void {
    event.preventDefault();

    if (!event.target.files) return;

    const file = event.target.files[0];

    async function uploadToIPFS(): Promise<void> {
      try {
       //const result = await client.add(file)

        // upload files
        const result = await (ipfs as IPFSHTTPClient).add(file);
        setImage(`https://ipfs.io/ipfs/${result.path}`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    uploadToIPFS();
  }

  function handleCreateNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer): Promise<void> {
      if (!image || !price || !name || !description) return;

      const NFT = new ethers.ContractFactory(
        OGNFTArtifact.abi,
        OGNFTArtifact.bytecode,
        signer
      );

      try {

        const nftContract = await NFT.attach(OGNFTAddress.address);
       
        const ticker = "CFX";
        const tickerId = 0;
        const result = await (ipfs as IPFSHTTPClient).add(JSON.stringify({image, price, name, description,ticker}));
        const uri = `https://ipfs.io/ipfs/${result.path}`;
       
        // mint nft - DON'T MINT FOR ALPHAS
      //  const result2 = await(await nftContract.mint(uri,tickerId)).wait();

        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();
        
        //window.alert(`Create NFT Success!`);
        window.alert(uri);

        handleClearForm();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer);
  }


  function handleApproveBUSD(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function approveBUSD(signer: Signer): Promise<void> {
     
   //   const BUSDLIVE = new ethers.ContractFactory(
   //     BUSD_LIVEArtifact.abi,
   //     BUSD_LIVEArtifact.bytecode,
   //     signer
   //   );

      const BUSD = new ethers.ContractFactory(
        BUSD_Artifact.abi,
        BUSD_Artifact.bytecode,
        signer
      );

      try {

        const BUSD_Contract = await BUSD.attach(BUSD_Address.address);

        const listingPrice = ethers.utils.parseEther("30000");

        const setTxn = await BUSD_Contract.approve('0x5FC8d32690cc91D4c39d9d3abcBD16989F875707',listingPrice); // = FFFFetc

        await setTxn.wait();

        window.alert(`Success!`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    approveBUSD(signer);
  }

  function handleApproveSAFUU(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function approveSAFUU(signer: Signer): Promise<void> {
     
   //   const BUSDLIVE = new ethers.ContractFactory(
   //     BUSD_LIVEArtifact.abi,
   //     BUSD_LIVEArtifact.bytecode,
   //     signer
   //   );

      const SAFUU = new ethers.ContractFactory(
        SAFUU_Artifact.abi,
        SAFUU_Artifact.bytecode,
        signer
      );

      try {

        const SAFUU_Contract = await SAFUU.attach(SAFUU_Address.address);

        const listingPrice = ethers.utils.parseEther("30000");

        const setTxn = await SAFUU_Contract.approve('0x5FC8d32690cc91D4c39d9d3abcBD16989F875707',listingPrice); // = FFFFetc

        await setTxn.wait();

        window.alert(`Success!`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    approveSAFUU(signer);
  }

  function handleCreateBUSDNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        OGNFTArtifact.abi,
        OGNFTArtifact.bytecode,
        signer
      );

      const BUSD = new ethers.ContractFactory(
        BUSD_Artifact.abi,
        BUSD_Artifact.bytecode,
        signer
      );

      try {

        const BUSD_Contract = await BUSD.attach(BUSD_Address.address);

        const amountApproved = await BUSD_Contract.allowance(account, OGNFTAddress.address);
        const balanceBUSD = await BUSD_Contract.balanceOf(account);

        //If not enough allowence left
        if (Number(amountApproved) < (Number(ethers.utils.parseEther('100'))) ) {
          //Do Approve BUSD

        const listingPrice = ethers.utils.parseEther("30000");

        const setTxn = await BUSD_Contract.approve(OGNFTAddress.address,listingPrice); // = FFFFetc

        await setTxn.wait();

        setBuyCFALPHAButton('MINT $CFALPHA NFT WITH BUSD');

        window.alert(`BUSD Approve Success!`);

        }

        if(Number(balanceBUSD) < Number(ethers.utils.parseEther('100'))) {
          window.alert('Not enough BUSD balance');
          return;
        }

        const nftContract = await NFT.attach(OGNFTAddress.address);
        //const nftMarketplaceContract = await NFTMarketplace.attach(NFTMarketplaceAddress.address);
        const ticker = "BUSD";
        const tickerId = 0;
       // const result = await (ipfs as IPFSHTTPClient).add(JSON.stringify({image, price, name, description,ticker}));
       //const uri = `https://ipfs.io/ipfs/${result.path}`;

       // const uri = `{"image":"https://ipfs.io/ipfs/QmZ364K1f2jmiFdseKRfZeECPBJip8U7ST68Hk6ekphZY1","price":"100","name":"Cosmic Force Alpha Cadet","description":"Cosmic Force Alpha Cadet NFT","ticker":"BUSD"}`;

        const uri = "https://ipfs.io/ipfs/QmYwFL6A1CWTn3UmcRcfsnaXT17a4LPZzAZRmNQwWnNUHw";
        // mint nft 
        const result2 = await(await nftContract.mint(uri,tickerId)).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));


        setBuyCFALPHAButton('MINT $CFALPHA NFT WITH BUSD');
        handleCheckApproveBUSD();

        window.alert(`Created ALPHA #${totalSupply} NFT`);


      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer);
  }

  function handleCreateSAFUUNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        OGNFTArtifact.abi,
        OGNFTArtifact.bytecode,
        signer
      );

      const SAFUU = new ethers.ContractFactory(
        SAFUU_Artifact.abi,
        SAFUU_Artifact.bytecode,
        signer
      );

      try {

        const SAFUU_Contract = await SAFUU.attach(SAFUU_Address.address);

        const amountApproved = await SAFUU_Contract.allowance(account, OGNFTAddress.address);
        const balanceSAFUU = await SAFUU_Contract.balanceOf(account);

        //If not enough allowence left
        if (Number(amountApproved) < (Number(ethers.utils.parseEther('100'))) ) {
          //Do Approve BUSD

        const listingPrice =  "3000000000";

        const setTxn = await SAFUU_Contract.approve(OGNFTAddress.address,listingPrice);

        await setTxn.wait();

        setBuyCFALPHASafuuButton('MINT $CFALPHA NFT WITH SAFUU');

        window.alert(`SAFUU Approve Success!`);

        }

        //************* CHANGE WITH PRICE CHANGE */
        if(Number(balanceSAFUU) < Number("50000000")) {
          window.alert('Not enough SAFUU balance');
          return;
        }

        const nftContract = await NFT.attach(OGNFTAddress.address);
       
        const ticker = "SAFUU";
        const tickerId = 1;
        //const result = await (ipfs as IPFSHTTPClient).add(JSON.stringify({image, price, name, description,ticker}));
        //const uri = `https://ipfs.io/ipfs/${result.path}`;

        //const uri = `{"image":"https://ipfs.io/ipfs/QmZ364K1f2jmiFdseKRfZeECPBJip8U7ST68Hk6ekphZY1","price":"100","name":"Cosmic Force Alpha Cadet","description":"Cosmic Force Alpha Cadet NFT","ticker":"BUSD"}`;

        const uri = "https://ipfs.io/ipfs/QmYwFL6A1CWTn3UmcRcfsnaXT17a4LPZzAZRmNQwWnNUHw";
        // mint nft 
        await(await nftContract.mint(uri,tickerId)).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));

        setBuyCFALPHASafuuButton('MINT $CFALPHA NFT WITH SAFUU');
        handleCheckApproveSAFUU();

        window.alert(`Created ALPHA #${totalSupply} NFT`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer);
  }

  function handleCheckApproveBUSD(): void {
   
    // only attach when a signer is defined
    if (!signer) {
      return;
    }

  async function approveCheckBUSD(signer: Signer): Promise<void> {
      
      //   const BUSDLIVE = new ethers.ContractFactory(
      //     BUSD_LIVEArtifact.abi,
      //     BUSD_LIVEArtifact.bytecode,
      //     signer
      //   );
  
        const BUSD = new ethers.ContractFactory(
          BUSD_Artifact.abi,
          BUSD_Artifact.bytecode,
          signer
        );
  
        try {
  
          const BUSD_Contract = await BUSD.attach(BUSD_Address.address);
            
          const amountApproved = await BUSD_Contract.allowance(account,OGNFTAddress.address);
  
          const contractBalanceBUSD = await BUSD_Contract.balanceOf(OGNFTAddress.address);     
          const totalRaised = Number(ethers.utils.formatUnits(contractBalanceBUSD,18));
          setTotalBUSDRaised(Math.ceil(totalRaised));
          
    
          const walletNewBalanceBUSD = await BUSD_Contract.balanceOf(account);
          const newBalanceBUSD = Number(ethers.utils.formatUnits(walletNewBalanceBUSD,18));
          setbusdBalance(newBalanceBUSD);
  
          //If not enough allowence left
          if (Number(amountApproved) > 0) {
            setBuyCFALPHAButton('MINT $CFALPHA NFT WITH BUSD');
          } else {
            setBuyCFALPHAButton('APPROVE BUSD & MINT $CFALPHA NFT');
          }
          
        } catch (error: any) {
          window.alert(
            'Error!' + (error && error.message ? `\n\n${error.message}` : '')
          );
        }
      }
  
    approveCheckBUSD(signer);
  }

  function handleCheckApproveSAFUU(): void {
   
      // only attach when a signer is defined
      if (!signer) {
        return;
      }
  
      async function approveCheckSAFUU(signer: Signer): Promise<void> {
        
        //   const BUSDLIVE = new ethers.ContractFactory(
        //     BUSD_LIVEArtifact.abi,
        //     BUSD_LIVEArtifact.bytecode,
        //     signer
        //   );
    
          const SAFUU = new ethers.ContractFactory(
            SAFUU_Artifact.abi,
            SAFUU_Artifact.bytecode,
            signer
          );
    
          try {
    
            const SAFUU_Contract = await SAFUU.attach(SAFUU_Address.address);
              
            const amountApproved = await SAFUU_Contract.allowance(account,OGNFTAddress.address);
    
            const contractBalanceSAFUU = await SAFUU_Contract.balanceOf(OGNFTAddress.address);     
            const totalSafuuRaised = Number(ethers.utils.formatUnits(contractBalanceSAFUU,5));
            setTotalSAFUURaised(Math.ceil(totalSafuuRaised));
            
      
            const walletNewBalanceSAFUU = await SAFUU_Contract.balanceOf(account);
            const newBalanceSAFUU = Number(ethers.utils.formatUnits(walletNewBalanceSAFUU,5));
            setsafuuBalance(newBalanceSAFUU);
    
            //If not enough allowence left
            if (Number(amountApproved) > 0) {
              setBuyCFALPHASafuuButton('MINT $CFALPHA NFT WITH SAFUU');
            } else {
              setBuyCFALPHASafuuButton('APPROVE SAFUU & MINT $CFALPHA NFT');
            }
            
          } catch (error: any) {
            window.alert(
              'Error!' + (error && error.message ? `\n\n${error.message}` : '')
            );
          }
      }
    
    approveCheckSAFUU(signer);
  }

  function handleTransferBUSDAmountChange(event: ChangeEvent<HTMLInputElement>): void {
    event.preventDefault();
    setTransferBUSDAmountInput(event.target.value);
  }

  function handleTransferBUSDSubmit(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    if (!NFTContract) {
      window.alert('Undefined NFTContract');
      return;
    }

    if (!transferBUSDAmountInput) {
      window.alert('Amount cannot be empty');
      return;
    }

    async function submitBUSDTransfer(NFTContract: Contract): Promise<void> {
      try {

       // window.alert(ethers.utils.parseEther(transferBUSDAmountInput));

        //0 = BUSD
        const setTxn = await NFTContract.withdraw(transferBUSDAmountInput,0);

        await setTxn.wait();

        handleCheckApproveBUSD();

        window.alert(`Withdraw BUSD Success!`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    submitBUSDTransfer(NFTContract);
  }

  function handleTransferSAFUUAmountChange(event: ChangeEvent<HTMLInputElement>): void {
    event.preventDefault();
    setTransferSAFUUAmountInput(event.target.value);
  }

  function handleTransferSAFUUSubmit(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    if (!NFTContract) {
      window.alert('Undefined NFTContract');
      return;
    }

    if (!transferSAFUUAmountInput) {
      window.alert('Amount cannot be empty');
      return;
    }

    async function submitSAFUUTransfer(NFTContract: Contract): Promise<void> {
      try {

       // window.alert(ethers.utils.parseEther(transferSAFUUAmountInput));

        //1 = SAFUU
        const setTxn = await NFTContract.withdraw(transferSAFUUAmountInput,1);

        await setTxn.wait();

        handleCheckApproveBUSD();

        window.alert(`Withdraw SAFUU Success!`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    submitSAFUUTransfer(NFTContract);
  }
 
  const handleClearForm = () => {

    //TODO clear form

  };
  
  return (
    <>
      <StyledGreetingDiv>
        <StyledLabel>Contract addr</StyledLabel>
        <div>
          {NFTContractAddr ? (
            NFTContractAddr
          ) : (
            <em>{`<Contract not yet deployed>`}</em>
          )}
        </div>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <div></div>
        <StyledLabel>Owner</StyledLabel>
        <div>
          {nftTokenOwner}
        </div>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <div></div>
        <StyledLabel>Name</StyledLabel>
        <div>
          {nftTokenName}
        </div>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <div></div>
        <StyledLabel>Symbol</StyledLabel>
        <div>
          {nftTokenSymbol}
        </div>
         {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
         <div></div>
         <StyledLabel>BUSD IN CONTRACT</StyledLabel>
         {totalBUSDRaised}
         <div></div>
        <StyledLabel htmlFor="transferInput">Withdraw BUSD To Admin</StyledLabel>
        <StyledInput
          id="transferAmountInput"
          type="text"
          placeholder={transferBUSDAmountInput ? '' : '<Amount>'}
          onChange={handleTransferBUSDAmountChange}
          style={{ fontStyle: transferBUSDAmountInput ? 'normal' : 'italic' }}
        ></StyledInput>
        <StyledButton
          disabled={!active || !NFTContract ? true : false}
          style={{
            cursor: !active || !NFTContract ? 'not-allowed' : 'pointer',
            borderColor: !active || !NFTContract ? 'unset' : 'blue'
          }}
          onClick={handleTransferBUSDSubmit}
        >
          Submit Withdraw
        </StyledButton>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <StyledLabel>SAFUU IN CONTRACT</StyledLabel>
        {totalSAFUURaised}
        <div></div>
        <StyledLabel htmlFor="transferInput">Withdraw SAFUU To Admin</StyledLabel>
        <StyledInput
          id="transferAmountInput"
          type="text"
          placeholder={transferSAFUUAmountInput ? '' : '<Amount>'}
          onChange={handleTransferSAFUUAmountChange}
          style={{ fontStyle: transferSAFUUAmountInput ? 'normal' : 'italic' }}
        ></StyledInput>
        <StyledButton
          disabled={!active || !NFTContract ? true : false}
          style={{
            cursor: !active || !NFTContract ? 'not-allowed' : 'pointer',
            borderColor: !active || !NFTContract ? 'unset' : 'blue'
          }}
          onClick={handleTransferSAFUUSubmit}
        >
          Submit Withdraw
        </StyledButton>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <div></div>
      </StyledGreetingDiv>
      <div className="container-fluid mt-5">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
            <Row className="g-4">
              <Form.Control
                type="file"
                required
                name="file"
                onChange={handleUploadToIPFS}
              />
              <Form.Control onChange={(e) => setName(e.target.value)} size="lg" required type="text" placeholder="Name" ref={reffirstRef} />
              <Form.Control onChange={(e) => setDescription(e.target.value)} size="lg" required as="textarea" placeholder="Description" />
              <Form.Control onChange={(e) => setPrice(e.target.value)} size="lg" required type="number" placeholder="Price in CFX" />
              <div className="d-grid px-0">
                <Button onClick={handleCreateNFT} variant="primary" size="lg">
                  MINT ORIGINAL ALPHA NFT WITH DETAILS ABOVE
                </Button>
              </div>
              <div className="d-grid px-0">
                <Button onClick={handleApproveBUSD} variant="primary" size="lg">
                  APPROVE BUSD
                </Button>
              </div>
              <div className="d-grid px-0">
                <Button onClick={handleApproveSAFUU} variant="primary" size="lg">
                  APPROVE SAFUU
                </Button>
              </div>
            </Row>

            
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Contract: {NFTContractAddr}
            </h6>
            </Row>
            <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <h4 className="text-center">
              Minted
            </h4>
            </Col>
            <Col>
            <h4 className="text-center">
              Max Supply
            </h4>
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <h5 className="text-center">
              {totalNFTSupply}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              2,100
            </h5>
            </Col>
            <Col>
            </Col>
          </Row>
            <Row className="g-8">
            <Col>
            </Col>
            <Col>
            <img src='./images/ALPHA.png' className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <h5 className="p-1 text-center">
              1 $CFALPHA NFT = 100 $BUSD or 500 SAFUU (NO 16% SAFUU SELL TAX WILL BE TAKEN)
            </h5>
          </Row>
            <Row className="g-4">

            <Col>
              <div className="d-grid px-0">
                <Button onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                  {buyCFALPHAButton}
                </Button>
              </div>
              </Col>
              <Col>
              <div className="d-grid px-0">
                <Button onClick={handleCreateSAFUUNFT} variant="primary" size="lg">
                  {buyCFALPHASafuuButton}
                </Button>
              </div>
              </Col>
              
            </Row>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
